module.exports = __webpack_public_path__ + "img/amsFA6.37395d75.png";